import { type FieldErrors, get } from 'react-hook-form'
import type { WorkwiseFormValues } from '@/types/workwise'

/** The message react-hook-form holds for a dotted field path, if any. */
export function errorAt(errors: FieldErrors<WorkwiseFormValues>, path: string): string | undefined {
  const entry = get(errors, path) as { message?: unknown } | undefined
  return typeof entry?.message === 'string' ? entry.message : undefined
}

/** A DOM id that is stable for a field path, e.g. "appServer.vmName" -> "ww-appServer-vmName". */
export function fieldId(path: string): string {
  return `ww-${path.replace(/[^A-Za-z0-9]+/g, '-')}`
}
